import { useFeatures } from '@/contexts/root-store-context'
import { observer } from 'mobx-react-lite'
import { lazy } from 'react'

const Inner = lazy(() => import('./Inner'))

/**
 * Component that hosts all dialogs needed for documents that may be invoked
 * from anywhere else in the app.
 */
export const DocumentDialogsHost = observer(function DocumentDialogsHost() {
  const { isDocsRequested } = useFeatures(({ docs }) => ({
    isDocsRequested: docs.internal.isRequested,
  }))

  // Defer loading the meat of the docs module until
  // something requests its use.
  if (!isDocsRequested()) {
    return null
  }

  return <Inner />
})
